import {ShapeCommand} from '../commands.template';

export class ActivityRenumberCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  reverseData: any;

  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  public prepareData() {
    return this;
  }

  public execute() {
    super.execute();
    const list = this.object.map(item => {
      return {
        mxKey: Number(item.mxKey),
        number: item.number
      };
    });

    const action = {groupRenumber: {list}};

    this.services.diagramUpdateSvc.update(action);
    this.redrawActivities(list.map(item => item.mxKey));
  }

  public reverse() {
    super.reverse();
    const list = this.object.map(item => {
      return {
        mxKey: Number(item.mxKey),
        number: item.oldNumber
      };
    });

    const action = {groupRenumber: {list}};

    this.services.diagramUpdateSvc.update(action);
    this.redrawActivities(list.map(item => item.mxKey));
  }

  private redrawActivities(activityMxKeys) {
    activityMxKeys.forEach(activityMxKey => {
      this.services.editorRegistrySvc
        .getGraph()
        .model.getCell(Number(activityMxKey))
        .comp.instance.setupFromJson();
    });
  }
}
